export const BAMBOU_LIST_REQUEST    = 'BAMBOU_LIST_REQUEST';
export const BAMBOU_LIST_SUCCESS    = 'BAMBOU_LIST_SUCCESS';
export const BAMBOU_LIST_FAIL       = 'BAMBOU_LIST_FAIL';
export const BAMBOU_LIST_UPDATE     = 'BAMBOU_LIST_UPDATE';